
import React, { useState } from 'react';
import { Form, Modal, Row, Col, OverlayTrigger, Tooltip, Image, Button } from 'react-bootstrap';
import Loader from '../../../../Loader/Loader';
import callAPI from '../../../../../../commonservices/APIRequests';
import { Plus } from 'lucide-react';
import fileUploadIcon from "../../../../../../assets/images/Popup-Icons/PopupIcons_UploadClipIcon.svg";
import eyeIcon from '../../../../../../assets/images/Action-Icons/Eye-Icon.svg';
import deleteIcon from '../../../../../../assets/images/Icons/deleteIcon.svg';
import fileDownloadIcon from '../../../../../../assets/images/Action-Icons/Download-Icon.svg';
import { checkFileFormat, downloadFile, fileToBase64, payloadFileFormat, viewDocument } from '../../../../../../commonservices/CommonMethods';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSampleBankDocuments } from '../../../../../../store/Actions/Actions';
import InfoIcon from '../../../../../../assets/images/info-icon-v2.svg'




const BankDocumentPopup = (props) => {

    const [validation, setValidation] = useState(false);
    const [bankData, setBankUpdate] = useState({
        achForm: {},
        voidedCheck: {},
        achFormDocument: {},
        voidedCheckDocument: {},
        bankStatus: '',
        _id: ''
    });
    const [achFileDetails, setAchFileDetails] = useState([])
    const [voidedCheckFileDetails, setVoidedFileDetails] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [docmentDelete, setDocmentDelete] = useState({
        type: '',
        showModal: false,
        id: ''
    });
    const sampleDocument = useSelector((store)=> store.sharedReducer?.masterData?.sampleBankDocuments)
    const dispatch = useDispatch()



    const resetData = () => {
        setBankUpdate({});
        setValidation(false);
        setAchFileDetails([]);
        setVoidedFileDetails([]);
        props.setshowModalPopup(false)
    }
    //banks from plaid account
    useEffect(() => {
        if (props?.documents?.length > 0) {

            if (props.documents[0].documentType === "bankVoidedCheck") {

                setBankUpdate({
                    ...bankData,
                    voidCheck: props.documents,
                })
            } else if (props.documents[0].documentType === 'bankAchForm') {
                setBankUpdate({
                    ...bankData,
                    achForm: props.documents
                })
            }
        }

    }, [props?.documents])


    useEffect(() => {
        if (localStorage.getItem('token') && !sampleDocument.length) {
            dispatch(getSampleBankDocuments());
        }
    }, [ sampleDocument])


    const checkData = () => {

        if (achFileDetails?.length > 0 || voidedCheckFileDetails?.length > 0) {
            return false;
        }

        return true;
    }



    const handleBankAccount = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setValidation(true);
        const form = event.currentTarget;
        const achdoc = {
            fileType: payloadFileFormat(achFileDetails[0]?.fileName, achFileDetails[0]?.fileType),
            fileName: achFileDetails[0]?.fileName,
            base64Image: achFileDetails[0]?.base64Image
        }
        const voidedcheck = {
            fileType: payloadFileFormat(voidedCheckFileDetails[0]?.fileName, voidedCheckFileDetails[0]?.fileType),
            fileName: voidedCheckFileDetails[0]?.fileName,
            base64Image: voidedCheckFileDetails[0]?.base64Image
        }
        const req = {
            dealer_id: props.dealer_id,
            bankId: props?.bankId
        }

        if (voidedcheck?.base64Image) {
            req.voidedCheck = voidedcheck
        }

        if (achdoc?.base64Image) {
            req.achForm = achdoc
        }


        if (form.checkValidity() !== false) {
            setShowLoader(true)
            callAPI.post("/payment/api/v1/payments/saveBankDetails", req)
                .then((response) => {
                    if (response.status === 200) {
                        setShowLoader(false)
                        if(props.addBankAccount){
                            props.addBankAccount()
                        }
                        props.setToaster({
                            header: 'success',
                            class: 'success-toaster',
                            content: "Banks documents saved successfully.",
                            showToaster: true
                        });
                        resetData();
                        setValidation(false);
                        if (props.refreshData)
                            props.refreshData();
                    }
                    else {
                        setShowLoader(false)
                        setValidation(false);
                        props.setToaster({
                            header: 'Error',
                            class: 'error-toaster',
                            content: response.message ? response.message : "Something went wrong.",
                            showToaster: true
                        });

                    }
                })

        }
    };




    const docConfirmationClose = () => {
        setDocmentDelete({
            type: '',
            showModal: false
        })
    }

    const onFileDelete = (event, type, id) => {
        if (event) {
            event.preventDefault()
            event.stopPropagation()
        }


        const req = {
            documentId: type === 'achForm' ? bankData?.achFormDocument?.documentId : bankData?.voidedCheckDocument?.documentId
        }
        setShowLoader(true)

        if (!req.documentId) {
            if (type === 'achForm') {
                setAchFileDetails([])
            }
            else {
                setVoidedFileDetails([])
            }
            setDocmentDelete({
                type: "",
                showModal: false,
                id: ''
            })
            setShowLoader(false);
            return;
        }



        return callAPI.post('/payment/api/v1/payments/deleteBankDocument', req)
            .then((response) => {
                if (response.status === 200) {

                    props.setToaster({
                        header: 'Success',
                        class: 'success-toaster',
                        content: 'Document deleted successfully.',
                        showToaster: true
                    });

                    

                    setDocmentDelete({
                        type: "",
                        showModal: false,
                        id: ''
                    })



                    if (type === 'achForm') {
                        setBankUpdate({
                            ...bankData,
                            achFormDocument: {

                            }
                        })
                        setAchFileDetails([]);
                        props.getViewDetails();
                    }
                    else {
                        setBankUpdate({
                            ...bankData,
                            voidedCheckDocument: {

                            }
                        })
                        setVoidedFileDetails([])
                        props.getViewDetails();
                    }
                    setShowLoader(false)
                } else {
                    props.setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: response.message,
                        showToaster: true
                    })
                    setShowLoader(false)
                }
            })
    }


    const getDocument = (event, id) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        setShowLoader(true);
        return callAPI.get('/lender/api/v1/dealer/getDocument?documentId=' + id)
            .then((response) => {

                if (response.status === 200) {
                    setShowLoader(false);
                    viewDocument(response.data.fileType, response.data.url);
                }
                else {
                    setShowLoader(false);
                }

            })

    }

    const onFileDeleteConfirmation = (event, type, id) => {
        setDocmentDelete({
            type,
            showModal: true
        })
    }


    const DeleteDocument = (type, id) => {

        const req = {
            documentId: id,
            label: type
        }

        callAPI.delWithParams('/vehicle/api/v1/dealers/deleteDocument', req)
            .then(res => {
                if (res.status === 200) {
                    let data = { ...bankData }
                    if (type === 'voidCheck') {
                        let removeDoc = data.voidCheck;
                        removeDoc.splice(0, 1);
                        data.voidCheck = removeDoc
                    } else {
                        let removeDoc = data.achForm;
                        data.achForm = removeDoc
                        removeDoc.splice(0, 1);
                    }
                    setBankUpdate(data)
                    if(props.addBankAccount){
                        props.addBankAccount()
                    }

                    props.setToaster({
                        header: 'Success',
                        class: 'success-toaster',
                        content: 'Document deleted successfully.',
                        showToaster: true
                    });
                } else {
                    props.setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: res.message,
                        showToaster: true
                    })
                }

            })

    }
    const fileHandler = async (event, docType) => {
        const file = event.target.files[0];
        if (file?.size > 10485760) {
            props.setToaster({
                header: 'Error',
                class: 'error-toaster',
                content: 'File size is too large, please upload a file smaller than 10MB.',
                showToaster: true
            });
            return;
        }
        const isValid = checkFileFormat(file, props.setToaster, ['.pdf', '.jpg', '.jpeg', '.png', '.heic']);

        if (!isValid) {
            // Stop further execution because the file format is invalid
            return;
        }
        if (docType === 'achForm') {
            let data = []
            if (file.name) {
                data.push({
                    fileName: file.name,
                    base64Image: await fileToBase64(file),
                    fileType: payloadFileFormat(file.name, file.type)
                })
            }
            setAchFileDetails(data);
        }
        else if (docType === 'voidedCheck') {
            let data = []
            if (file.name) {
                data.push({
                    fileName: file.name,
                    base64Image: await fileToBase64(file),
                    fileType: payloadFileFormat(file.name, file.type)
                })
            }

            setVoidedFileDetails(data);
        }

    }

    return (
        <>
            <Modal className={`default-popup modal-backdrop-bg-color default-medium-popup add-update-location`} show={props.showModal} onHide={() => resetData()} backdrop={props.isStatic ? "static" : null}>
                <Loader show={props.showLoade || showLoader} styleType='absolute' />
                <Modal.Header className='darkblue-bg-color' closeButton={true}>
                    <Modal.Title>
                        <span className='popup-title-icon'><Plus /></span>
                        <span className='flex-grow-1'>Add Bank Documents</span>
                    </Modal.Title>
                </Modal.Header>


                <Modal.Body>
                    <Form noValidate
                        validated={validation}
                        onSubmit={(event) => handleBankAccount(event)}
                    >
                        <Row className="align-items-start">
                            <Col md={6} className='mb-3'>
                                <div>
                                    <div className='d-flex justify-content-between'>
                                        <p>Voided Check</p>
                                        <span onClick={() => downloadFile(sampleDocument.find((doc) => doc.label === "bankVoidedCheck").value, "bankVoidedCheck.jpeg")}>
                                            <small className='mr-1 d-inline'>Sample File</small>
                                            <OverlayTrigger placement="bottom"
                                                overlay={
                                                    <Tooltip>Download</Tooltip>}>
                                                <Image className="cursor-pointer img-14px d-inline mb-1" src={fileDownloadIcon} width={15} alt="sample-file-icon" />
                                            </OverlayTrigger>
                                        </span>
                                    </div>
                                    <div className="default-document-item">
                                        <div className="document-label d-flex align-items-center text-left ">
                                            <Image src={fileUploadIcon} alt="additioncost-image" />
                                            <p className="default-document-label ml-2">Choose your Document or Drop your Document</p>
                                        </div>
                                        <input
                                            type="file"
                                            id='attachFile'
                                            multiple={true}
                                            className="default-file-upload"
                                            onChange={event => fileHandler(event, 'voidedCheck')}
                                            disabled={voidedCheckFileDetails.length > 0 ? true : false}
                                        />
                                    </div>
                                    <small className='secondary-text-color d-flex align-items-center mt-1'>
                                        <Image src={InfoIcon} alt='info' className='common-info-icon' />
                                        <span className='ml-1'>Allowed types: PDF, JPG, JPEG, PNG, HEIC</span>
                                    </small>
                                    {voidedCheckFileDetails.length > 0 && voidedCheckFileDetails[0]?.fileName ? <p className='break-all-text mb-2 mt-1' >
                                        <small className="secondary-text-color">{voidedCheckFileDetails[0]?.fileName} { }</small>
                                        <span classname="cursor-pointer">
                                            <OverlayTrigger placement="bottom"
                                                overlay={
                                                    <Tooltip>View</Tooltip>}>
                                                <Image src={eyeIcon} onClick={(event) => { voidedCheckFileDetails[0]?.base64Image ? viewDocument(voidedCheckFileDetails[0]?.fileType, voidedCheckFileDetails[0]?.base64Image) : getDocument(event, bankData?.voidedCheckDocument?.documentId) }} className="ml-1 eyeIcon-in-table cursor-pointer" />
                                            </OverlayTrigger>
                                            <OverlayTrigger placement="bottom"
                                                overlay={
                                                    <Tooltip>Delete</Tooltip>}>
                                                <Image src={deleteIcon} className="ml-1 cursor-pointer delete-icon" onClick={(event) => {
                                                    onFileDeleteConfirmation(event, "voidedCheck")
                                                }} />
                                            </OverlayTrigger>
                                        </span>
                                    </p> :
                                        bankData?.voidCheck?.length > 0 ? <p className='break-all-text mb-2 mt-1' >
                                            <small className="secondary-text-color">{bankData?.voidCheck[0]?.fileName} { }</small>
                                            <span classname="cursor-pointer">
                                                <OverlayTrigger placement="bottom"
                                                    overlay={
                                                        <Tooltip>View</Tooltip>}>
                                                    <Image src={eyeIcon} onClick={(event) => getDocument(event, bankData?.voidCheck[0]._id)} className="ml-1 eyeIcon-in-table cursor-pointer" />
                                                </OverlayTrigger>
                                                <OverlayTrigger placement="bottom"
                                                    overlay={
                                                        <Tooltip>Delete</Tooltip>}>
                                                    <Image src={deleteIcon} className="ml-1 cursor-pointer delete-icon" onClick={() => DeleteDocument('voidCheck', bankData?.voidCheck[0]._id)} />
                                                </OverlayTrigger>
                                            </span>
                                        </p> : null}
                                </div>
                            </Col>

                            <Col md={6} className='mb-3'>
                                <div>
                                    <div className='d-flex justify-content-between'>
                                        <p>Ach Form</p>
                                        <span onClick={() => downloadFile(sampleDocument.find((doc) => doc.label === "bankAchForm").value, "bankAchForm.png")}>
                                            <small className='mr-1 d-inline'>Sample File</small>
                                            <OverlayTrigger placement="bottom"
                                                overlay={
                                                    <Tooltip>Download</Tooltip>}>
                                                <Image className="cursor-pointer d-inline mb-1" src={fileDownloadIcon} alt="sample-file-icon" width={15}
                                                />
                                            </OverlayTrigger>
                                        </span>
                                    </div>

                                    <div className="default-document-item">
                                        <div className="document-label d-flex align-items-center text-left ">
                                            <Image src={fileUploadIcon} alt="additioncost-image" />
                                            <p className="default-document-label ml-2">Choose your Document or Drop your Document</p>
                                        </div>
                                        <input
                                            type="file"
                                            id='attachFile'
                                            className="default-file-upload"
                                            onChange={event => fileHandler(event, 'achForm')}
                                            disabled={achFileDetails.length > 0 ? true : false}
                                        />
                                    </div>
                                    <small className='secondary-text-color d-flex align-items-center mt-1'>
                                        <Image src={InfoIcon} alt='info' className='common-info-icon' />
                                        <span className='ml-1'>Allowed types: PDF, JPG, JPEG, PNG, HEIC</span>
                                    </small>
                                    {achFileDetails.length > 0 && achFileDetails[0]?.fileName ? <p className='break-all-text mb-2 mt-1'>
                                        <small className="secondary-text-color">{achFileDetails[0]?.fileName} { }</small>
                                        <span classname="cursor-pointer">
                                            <OverlayTrigger placement="bottom"
                                                overlay={
                                                    <Tooltip>View</Tooltip>}>
                                                <Image src={eyeIcon} onClick={(event) => achFileDetails[0].base64Image ? viewDocument(achFileDetails[0].fileType, achFileDetails[0].base64Image) : getDocument(event, bankData?.achFormDocument?.documentId)} className="ml-1 eyeIcon-in-table cursor-pointer" />
                                            </OverlayTrigger>
                                            <OverlayTrigger placement="bottom"
                                                overlay={
                                                    <Tooltip>Delete</Tooltip>}>
                                                <Image src={deleteIcon} className="ml-1 cursor-pointer delete-icon" onClick={(event) => {

                                                    onFileDeleteConfirmation(event, "achForm")

                                                }} />
                                            </OverlayTrigger>
                                        </span>
                                    </p> :
                                        bankData?.achForm?.length > 0 ? <p className='break-all-text mb-2 mt-1' >
                                            <small className="secondary-text-color">{bankData?.achForm[0]?.fileName} { }</small>
                                            <span classname="cursor-pointer">
                                                <OverlayTrigger placement="bottom"
                                                    overlay={
                                                        <Tooltip>View</Tooltip>}>
                                                    <Image src={eyeIcon} onClick={(event) => getDocument(event, bankData?.achForm[0]._id)} className="ml-1 eyeIcon-in-table cursor-pointer" />
                                                </OverlayTrigger>
                                                <OverlayTrigger placement="bottom"
                                                    overlay={
                                                        <Tooltip>Delete</Tooltip>}>
                                                    <Image src={deleteIcon} className="ml-1 cursor-pointer delete-icon" onClick={() => DeleteDocument('achForm', bankData?.achForm[0]._id)} />
                                                </OverlayTrigger>
                                            </span>
                                        </p> : null}
                                </div>
                            </Col>
                        </Row>
                        <div className="text-xs-center mt-1">
                            <Button type="submit" variant="primary" className="default-btn" disabled={checkData()}>Save</Button>
                            <Button type="button" variant="outline-secondary" className="default-btn ml-3"
                                onClick={() => resetData()
                                }
                            >Cancel</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            <ConfirmationPopup
                title="Are you sure you want to delete the document?"
                onClose={() => docConfirmationClose()}
                showModal={docmentDelete.showModal}
                primaryActionLabel="Yes"
                secondaryActionLabel="No"
                primaryAction={(event) => onFileDelete(event, docmentDelete.type)}
                secondaryAction={() => docConfirmationClose()}
            />
        </>



    )
}

export default BankDocumentPopup;